import {
  IndividualQuota,
  NestedQuota,
} from '../../shared/interfaces/quota.interface';

export class NestedQuotaPercentageMechanic {
  constructor(
    private readonly _nestedQuotas: NestedQuota[],
    private readonly _surveyAllocation: number
  ) {}

  public repair(): NestedQuota[] {
    return this._nestedQuotas.map((nestedQuota) => ({
      ...nestedQuota,
      percentage: this._percentage(nestedQuota.required_count),
      ...(nestedQuota.individual_quotas?.length && {
        individual_quotas: this._repairIndividualQuotas(
          nestedQuota.individual_quotas
        ),
      }),
    }));
  }

  private _repairIndividualQuotas(
    individualQuotas: IndividualQuota[]
  ): IndividualQuota[] {
    return individualQuotas.map((quota) => ({
      ...quota,
      allocation: {
        ...quota.allocation,
        percentage: this._percentage(quota.allocation.quantity),
      },
    }));
  }

  private _percentage(count: number): number {
    return Math.floor((100 * (count || 0)) / this._surveyAllocation);
  }
}
